/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneJwVideoShoppable from 'base/components/standalone/JwVideo/Shoppable';

export const DynamicStandaloneJwVideoShoppable = StandaloneJwVideoShoppable;
export type DynamicStandaloneJwVideoShoppableProps = PropsFromComponent<typeof StandaloneJwVideoShoppable>;

export const DynamicStandaloneJwVideoShoppableWith = (extras: DynamicStandaloneExtras): typeof StandaloneJwVideoShoppable => {
    return function DynamicStandaloneJwVideoShoppable(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'JwVideoShoppable');
        return <StandaloneJwVideoShoppable {...mergeProps({ options: { theme } }, props)} />;
    }
}